import { injector } from '@asd-stan/injector/injector';

import { WGRepo } from '../api/working-group.repo';
import { WGService } from '../domain/wg.service';

import { WG_REPO, WG_SERVICE } from './constants';

injector.set(WG_REPO, new WGRepo());
injector.set(WG_SERVICE, new WGService());
